export default defineAppConfig({
    ui: {
        colors: {
            primary: 'red',
            secondary: 'blue',
            tertiary: 'purple',
            gray: 'cool',
        },
        input: {
            defaultVariants: {
                color: 'neutral'
            }
        },
        inputMenu: {
            defaultVariants: {
                color: 'neutral'
            }
        },
    }
})